<template>
  <a :href="to" @click.prevent="handleClick">
    <slot />
  </a>
</template>
<script>
export default {
  props: {
    to: String,
  },
  methods: {
    handleClick(e) {
      const el = document.querySelector(e.target.hash);
      if (el instanceof HTMLElement) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }
    },
  },
};
</script>
